import { ChevronLeft, ChevronRight } from "lucide-react";

type PaginationProps = {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export function Pagination({ page, totalPages, onPageChange }: PaginationProps) {
  const getPages = () => {

    const max = 5;
    const fromEnd = (totalPages-page)
    let delta = Math.floor(max/2); // how many pages around current
    if (fromEnd < delta) {delta = delta + (delta - fromEnd)}

    const range = [];
    
    for (let i = page-delta; i <= totalPages; i++) {
        if (i>0) {
          range.push(i);
        }
        if (range.length == max) {
          break;
        }
    }

    return range;
  };

  return (
    <div className="flex items-center justify-center gap-2">
      {/* Prev */}
      <button
        onClick={() => onPageChange(page - 1)}
        disabled={page === 1}
        className="px-3 py-1 rounded-full border text-sm disabled:opacity-40"
      >
        <ChevronLeft className="size-4" />
      </button>

      {/* Pages */}
      {getPages().map((p, idx) =>
          <button
            key={p}
            onClick={() => onPageChange(p)}
            className={`px-3 py-1 rounded-full text-sm border transition
              ${
                p === page
                  ? "bg-black text-white"
                  : "hover:bg-gray-100"
              }`}
          >
            {p}
          </button>
        
      )}

      {/* Next */}
      <button
        onClick={() => onPageChange(page + 1)}
        disabled={page === totalPages}
        className="px-3 py-1 rounded-full border text-sm disabled:opacity-40"
      >
        <ChevronRight className="size-4" />
      </button>
    </div>
  );
}